module.exports = __webpack_public_path__ + "static/img/osde-1.6f28533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/osde-1.jpg
// module id = wZj9
// module chunks = 1